module.exports = __webpack_public_path__ + "img/quality-logo.fb1b0b6d.png";